import colors from 'styles/colors'
import fontSize from 'styles/fontSize'
import { fontWeight } from './fontWeight'
import shadow from 'styles/shadowV2'
import spacing from 'styles/spacingV2'
import { space as spacingV3 } from 'styles/spacingV3'
import radius from 'styles/radius'

export const theme = {
  colors,
  fontSize,
  fontWeight,
  spacing: { ...spacing, ...spacingV3 },
  shadow,
  radius,
}

export type Theme = typeof theme
